// ⛔️Generated file. Manual changes will be lost ⛔️

export const I18nKeys = {
    account: {
        title: 'account.title',
        signOut: 'account.signOut',
        languageLabel: 'account.languageLabel',
        languagePickerLead: 'account.languagePickerLead',
        profile: 'account.profile',
        emailLabel: 'account.emailLabel',
        displayNameLabel: 'account.displayNameLabel',
        scriptPreferenceLabel: 'account.scriptPreferenceLabel',
        scriptTraditional: 'account.scriptTraditional',
        scriptSimplified: 'account.scriptSimplified',
        scriptSheetLead: 'account.scriptSheetLead',
        scriptSwitchTitle: 'account.scriptSwitchTitle',
        scriptSwitchLead: 'account.scriptSwitchLead',
        scriptSwitchErasedHead: 'account.scriptSwitchErasedHead',
        scriptSwitchErasedItem: 'account.scriptSwitchErasedItem',
        scriptSwitchSurvivesHead: 'account.scriptSwitchSurvivesHead',
        scriptSwitchSurvivesListening: 'account.scriptSwitchSurvivesListening',
        scriptSwitchSurvivesIdentical: 'account.scriptSwitchSurvivesIdentical',
        scriptSwitchSurvivesPlan: 'account.scriptSwitchSurvivesPlan',
        scriptSwitchKeepCta: 'account.scriptSwitchKeepCta',
        scriptSwitchCta: 'account.scriptSwitchCta',
        scriptSwitchError: 'account.scriptSwitchError',
        signOutUnsyncedTitle: 'account.signOutUnsyncedTitle',
        signOutUnsyncedLead: 'account.signOutUnsyncedLead',
        signOutUnsyncedErasedHead: 'account.signOutUnsyncedErasedHead',
        signOutUnsyncedErasedItem: 'account.signOutUnsyncedErasedItem',
        signOutUnsyncedSurvivesHead: 'account.signOutUnsyncedSurvivesHead',
        signOutUnsyncedSurvivesItem: 'account.signOutUnsyncedSurvivesItem',
        signOutSyncCta: 'account.signOutSyncCta',
        signOutAnywayCta: 'account.signOutAnywayCta',
        signOutSyncFailed: 'account.signOutSyncFailed',
        scriptChangeInApp: 'account.scriptChangeInApp',
        localeLabel: 'account.localeLabel',
        profileLockNote: 'account.profileLockNote',
        study: 'account.study',
        newWordsLabel: 'account.newWordsLabel',
        newWordsHelp: 'account.newWordsHelp',
        ratingLabel: 'account.ratingLabel',
        ratingPreselect: 'account.ratingPreselect',
        ratingAutomatic: 'account.ratingAutomatic',
        ratingManual: 'account.ratingManual',
        ratingHelpPreselect: 'account.ratingHelpPreselect',
        ratingHelpAutomatic: 'account.ratingHelpAutomatic',
        ratingHelpManual: 'account.ratingHelpManual',
        ratingNote: 'account.ratingNote',
        subscription: 'account.subscription',
        currentPlan: 'account.currentPlan',
        freePlan: 'account.freePlan',
        subscriptionBody: 'account.subscriptionBody',
        upgradePlan: 'account.upgradePlan',
        patreon: 'account.patreon',
        membership: 'account.membership',
        notLinked: 'account.notLinked',
        patreonBody: 'account.patreonBody',
        linkPatreon: 'account.linkPatreon',
        manageMembership: 'account.manageMembership',
        termsPrivacy: 'account.termsPrivacy',
        about: 'account.about',
        version: 'account.version',
        deleteAccount: 'account.deleteAccount',
        deleteBody: 'account.deleteBody',
        deleteConfirmTitle: 'account.deleteConfirmTitle',
        deleteConfirmLead: 'account.deleteConfirmLead',
        deleteErasedHead: 'account.deleteErasedHead',
        deleteErasedAccount: 'account.deleteErasedAccount',
        deleteErasedProgress: 'account.deleteErasedProgress',
        deleteErasedPlan: 'account.deleteErasedPlan',
        deleteKeepCta: 'account.deleteKeepCta',
        deleteCta: 'account.deleteCta',
        deleteError: 'account.deleteError',
        deleteConfirmWarning: 'account.deleteConfirmWarning',
        deleteConfirm: 'account.deleteConfirm',
        deleting: 'account.deleting',
        syncing: 'account.syncing',
        strokeDataTitle: 'account.strokeDataTitle',
        strokeDataCredit: 'account.strokeDataCredit',
    },
    appearance: {
        title: 'appearance.title',
        day: 'appearance.day',
        night: 'appearance.night',
        system: 'appearance.system',
        systemSub: 'appearance.systemSub',
    },
    audio: {
        replay: 'audio.replay',
        unavailable: 'audio.unavailable',
    },
    authBrand: {
        heading: 'authBrand.heading',
        body: 'authBrand.body',
        point1Bold: 'authBrand.point1Bold',
        point1Text: 'authBrand.point1Text',
        point2Bold: 'authBrand.point2Bold',
        point2Text: 'authBrand.point2Text',
        point3Bold: 'authBrand.point3Bold',
        point3Text: 'authBrand.point3Text',
        footer: 'authBrand.footer',
    },
    blockDetail: {
        inThisBlock: 'blockDetail.inThisBlock',
        wordCount: 'blockDetail.wordCount',
        referenceCount: 'blockDetail.referenceCount',
        studyCta: 'blockDetail.studyCta',
        masteryByFamily: 'blockDetail.masteryByFamily',
        addCta: 'blockDetail.addCta',
        addLockedNote: 'blockDetail.addLockedNote',
        removeCta: 'blockDetail.removeCta',
        lockedNote: 'blockDetail.lockedNote',
        retainedProgressNote: 'blockDetail.retainedProgressNote',
        addedNote: 'blockDetail.addedNote',
        removedKeptNote: 'blockDetail.removedKeptNote',
        removedDroppedNote: 'blockDetail.removedDroppedNote',
        removeTitle: 'blockDetail.removeTitle',
        removeLead: 'blockDetail.removeLead',
        removeAlsoCardsName: 'blockDetail.removeAlsoCardsName',
        removeAlsoCardsMeta: 'blockDetail.removeAlsoCardsMeta',
        removeKeepCardsName: 'blockDetail.removeKeepCardsName',
        removeKeepCardsMeta: 'blockDetail.removeKeepCardsMeta',
        removeReassurance: 'blockDetail.removeReassurance',
        removeConfirmCta: 'blockDetail.removeConfirmCta',
        dueCountNote: 'blockDetail.dueCountNote',
        nothingDueNote: 'blockDetail.nothingDueNote',
        newWordsPausedNote: 'blockDetail.newWordsPausedNote',
    },
    blockRow: {
        eyebrow: 'blockRow.eyebrow',
    },
    cards: {
        subtitle: 'cards.subtitle',
        search: 'cards.search',
        maturityAny: 'cards.maturityAny',
        bandNew: 'cards.bandNew',
        bandLearning: 'cards.bandLearning',
        bandMature: 'cards.bandMature',
        bandLapsed: 'cards.bandLapsed',
        empty: 'cards.empty',
        detailHeader: 'cards.detailHeader',
        detailAppearsIn: 'cards.detailAppearsIn',
        detailScheduling: 'cards.detailScheduling',
        detailRecentReviews: 'cards.detailRecentReviews',
        detailDue: 'cards.detailDue',
        detailIntervalDays: 'cards.detailIntervalDays',
        detailReviews: 'cards.detailReviews',
        detailLapses: 'cards.detailLapses',
        detailLastReviewed: 'cards.detailLastReviewed',
        detailResting: 'cards.detailResting',
        detailRestingMeta: 'cards.detailRestingMeta',
        ratingAgain: 'cards.ratingAgain',
        ratingHard: 'cards.ratingHard',
        ratingGood: 'cards.ratingGood',
        ratingEasy: 'cards.ratingEasy',
        skillDefine: 'cards.skillDefine',
        skillListen: 'cards.skillListen',
        skillSay: 'cards.skillSay',
        skillReadAloud: 'cards.skillReadAloud',
        skillWrite: 'cards.skillWrite',
        familyMeaning: 'cards.familyMeaning',
        familyListening: 'cards.familyListening',
        familySpeaking: 'cards.familySpeaking',
        familyWriting: 'cards.familyWriting',
        typeAll: 'cards.typeAll',
        typeWord: 'cards.typeWord',
        typeWords: 'cards.typeWords',
        typeReference: 'cards.typeReference',
        typePattern: 'cards.typePattern',
        typeDialogue: 'cards.typeDialogue',
        detailCharacters: 'cards.detailCharacters',
        detailNoCards: 'cards.detailNoCards',
        detailExamples: 'cards.detailExamples',
        detailDialogue: 'cards.detailDialogue',
        referenceNote: 'cards.referenceNote',
        notStudiedTitle: 'cards.notStudiedTitle',
        notStudiedBody: 'cards.notStudiedBody',
        detailSchedulingSaved: 'cards.detailSchedulingSaved',
    },
    common: {
        appName: 'common.appName',
        back: 'common.back',
        cancel: 'common.cancel',
        close: 'common.close',
        startFree: 'common.startFree',
        createFreeAccount: 'common.createFreeAccount',
        signedInAs: 'common.signedInAs',
        comingSoon: 'common.comingSoon',
        termsOfService: 'common.termsOfService',
        privacyPolicy: 'common.privacyPolicy',
        version: 'common.version',
        footerCopyright: 'common.footerCopyright',
        tryAgain: 'common.tryAgain',
        studyAhead: 'common.studyAhead',
    },
    decisionGate: {
        scriptTitle: 'decisionGate.scriptTitle',
        scriptSub: 'decisionGate.scriptSub',
        traditionalName: 'decisionGate.traditionalName',
        traditionalMeta: 'decisionGate.traditionalMeta',
        simplifiedName: 'decisionGate.simplifiedName',
        simplifiedMeta: 'decisionGate.simplifiedMeta',
        choiceCaption: 'decisionGate.choiceCaption',
        changeLaterNote: 'decisionGate.changeLaterNote',
        continueCta: 'decisionGate.continueCta',
    },
    enterCode: {
        title: 'enterCode.title',
        subtitle: 'enterCode.subtitle',
        codeLabel: 'enterCode.codeLabel',
        codeInputAriaLabel: 'enterCode.codeInputAriaLabel',
        codeExpiry: 'enterCode.codeExpiry',
        loginFailed: 'enterCode.loginFailed',
        verify: 'enterCode.verify',
        verifying: 'enterCode.verifying',
        resendPrompt: 'enterCode.resendPrompt',
        resend: 'enterCode.resend',
        resendCooldown: 'enterCode.resendCooldown',
        switchPrompt: 'enterCode.switchPrompt',
        switchLink: 'enterCode.switchLink',
    },
    gate: {
        title: 'gate.title',
        subtitle: 'gate.subtitle',
        cardsChip: 'gate.cardsChip',
        xpChip: 'gate.xpChip',
        streakChip: 'gate.streakChip',
        streakExtended: 'gate.streakExtended',
        meterLabel: 'gate.meterLabel',
        meterThreshold: 'gate.meterThreshold',
        meterNudged: 'gate.meterNudged',
        meterHeld: 'gate.meterHeld',
        startNextSet: 'gate.startNextSet',
        takeBreak: 'gate.takeBreak',
        recapSubtitle: 'gate.recapSubtitle',
        studyAheadHint: 'gate.studyAheadHint',
        studyTheseCardsAgainHint: 'gate.studyTheseCardsAgainHint',
        recapRestudyHint: 'gate.recapRestudyHint',
        recapCardsHeader: 'gate.recapCardsHeader',
        recapCardsHint: 'gate.recapCardsHint',
        recapRetryFlag: 'gate.recapRetryFlag',
        recapViewerTitle: 'gate.recapViewerTitle',
        recapViewerAside: 'gate.recapViewerAside',
        recapViewerPrevious: 'gate.recapViewerPrevious',
        recapViewerNext: 'gate.recapViewerNext',
        recapViewerPosition: 'gate.recapViewerPosition',
        recapViewerHint: 'gate.recapViewerHint',
        recapNewWordHint: 'gate.recapNewWordHint',
    },
    header: {
        howItWorks: 'header.howItWorks',
        home: 'header.home',
        studyHome: 'header.studyHome',
        logIn: 'header.logIn',
        myAccount: 'header.myAccount',
    },
    home: {
        welcome: 'home.welcome',
        subtitle: 'home.subtitle',
        webSoonTitle: 'home.webSoonTitle',
        webSoonBody: 'home.webSoonBody',
        courseTitle: 'home.courseTitle',
        courseEmpty: 'home.courseEmpty',
    },
    howItWorks: {
        heroBadge: 'howItWorks.heroBadge',
        heroTitle: 'howItWorks.heroTitle',
        heroBody: 'howItWorks.heroBody',
        jumpLabel: 'howItWorks.jumpLabel',
        jumpBlocks: 'howItWorks.jumpBlocks',
        jumpPlan: 'howItWorks.jumpPlan',
        jumpCards: 'howItWorks.jumpCards',
        jumpSkills: 'howItWorks.jumpSkills',
        jumpOffline: 'howItWorks.jumpOffline',
        blocksEyebrow: 'howItWorks.blocksEyebrow',
        blocksTitle: 'howItWorks.blocksTitle',
        blocksLead: 'howItWorks.blocksLead',
        blocksPoint1Title: 'howItWorks.blocksPoint1Title',
        blocksPoint1Body: 'howItWorks.blocksPoint1Body',
        blocksPoint2Title: 'howItWorks.blocksPoint2Title',
        blocksPoint2Body: 'howItWorks.blocksPoint2Body',
        blocksPoint3Title: 'howItWorks.blocksPoint3Title',
        blocksPoint3Body: 'howItWorks.blocksPoint3Body',
        blocksShotAlt: 'howItWorks.blocksShotAlt',
        planEyebrow: 'howItWorks.planEyebrow',
        planTitle: 'howItWorks.planTitle',
        planLead: 'howItWorks.planLead',
        planPoint1Title: 'howItWorks.planPoint1Title',
        planPoint1Body: 'howItWorks.planPoint1Body',
        planPoint2Title: 'howItWorks.planPoint2Title',
        planPoint2Body: 'howItWorks.planPoint2Body',
        planPoint3Title: 'howItWorks.planPoint3Title',
        planPoint3Body: 'howItWorks.planPoint3Body',
        planShotAlt: 'howItWorks.planShotAlt',
        cardsEyebrow: 'howItWorks.cardsEyebrow',
        cardsTitle: 'howItWorks.cardsTitle',
        cardsLead: 'howItWorks.cardsLead',
        cardsPoint1Title: 'howItWorks.cardsPoint1Title',
        cardsPoint1Body: 'howItWorks.cardsPoint1Body',
        cardsPoint2Title: 'howItWorks.cardsPoint2Title',
        cardsPoint2Body: 'howItWorks.cardsPoint2Body',
        cardsPoint3Title: 'howItWorks.cardsPoint3Title',
        cardsPoint3Body: 'howItWorks.cardsPoint3Body',
        skillsEyebrow: 'howItWorks.skillsEyebrow',
        skillsTitle: 'howItWorks.skillsTitle',
        skillsLead: 'howItWorks.skillsLead',
        skillsPoint1Title: 'howItWorks.skillsPoint1Title',
        skillsPoint1Body: 'howItWorks.skillsPoint1Body',
        skillsPoint2Title: 'howItWorks.skillsPoint2Title',
        skillsPoint2Body: 'howItWorks.skillsPoint2Body',
        skillsPoint3Title: 'howItWorks.skillsPoint3Title',
        skillsPoint3Body: 'howItWorks.skillsPoint3Body',
        skillsShotAlt: 'howItWorks.skillsShotAlt',
        offlineEyebrow: 'howItWorks.offlineEyebrow',
        offlineTitle: 'howItWorks.offlineTitle',
        offlineLead: 'howItWorks.offlineLead',
        offlinePoint1Title: 'howItWorks.offlinePoint1Title',
        offlinePoint1Body: 'howItWorks.offlinePoint1Body',
        offlinePoint2Title: 'howItWorks.offlinePoint2Title',
        offlinePoint2Body: 'howItWorks.offlinePoint2Body',
        offlinePoint3Title: 'howItWorks.offlinePoint3Title',
        offlinePoint3Body: 'howItWorks.offlinePoint3Body',
        offlineShotAlt: 'howItWorks.offlineShotAlt',
        pickShapeLabel: 'howItWorks.pickShapeLabel',
        pickStateLabel: 'howItWorks.pickStateLabel',
        shapeDefine: 'howItWorks.shapeDefine',
        shapeListen: 'howItWorks.shapeListen',
        shapeSay: 'howItWorks.shapeSay',
        shapeReadAloud: 'howItWorks.shapeReadAloud',
        shapeWrite: 'howItWorks.shapeWrite',
        shapeDefineNote: 'howItWorks.shapeDefineNote',
        shapeListenNote: 'howItWorks.shapeListenNote',
        shapeSayNote: 'howItWorks.shapeSayNote',
        shapeReadAloudNote: 'howItWorks.shapeReadAloudNote',
        shapeWriteNote: 'howItWorks.shapeWriteNote',
        statePrompt: 'howItWorks.statePrompt',
        stateReveal: 'howItWorks.stateReveal',
        stateTones: 'howItWorks.stateTones',
        shapeDefinePromptAlt: 'howItWorks.shapeDefinePromptAlt',
        shapeDefineAnswerAlt: 'howItWorks.shapeDefineAnswerAlt',
        shapeListenPromptAlt: 'howItWorks.shapeListenPromptAlt',
        shapeListenAnswerAlt: 'howItWorks.shapeListenAnswerAlt',
        shapeSayPromptAlt: 'howItWorks.shapeSayPromptAlt',
        shapeSayTonesAlt: 'howItWorks.shapeSayTonesAlt',
        shapeSayAnswerAlt: 'howItWorks.shapeSayAnswerAlt',
        shapeReadAloudPromptAlt: 'howItWorks.shapeReadAloudPromptAlt',
        shapeReadAloudAnswerAlt: 'howItWorks.shapeReadAloudAnswerAlt',
        shapeWritePromptAlt: 'howItWorks.shapeWritePromptAlt',
        shapeWriteAnswerAlt: 'howItWorks.shapeWriteAnswerAlt',
        closingTitle: 'howItWorks.closingTitle',
        closingBody: 'howItWorks.closingBody',
    },
    landing: {
        heroBadge: 'landing.heroBadge',
        heroTitle: 'landing.heroTitle',
        heroBody: 'landing.heroBody',
        heroCtaSecondary: 'landing.heroCtaSecondary',
        heroFootnote: 'landing.heroFootnote',
        howTitle: 'landing.howTitle',
        howBody: 'landing.howBody',
        step1Title: 'landing.step1Title',
        step1Body: 'landing.step1Body',
        step1Line: 'landing.step1Line',
        step2Title: 'landing.step2Title',
        step2Body: 'landing.step2Body',
        step2Line: 'landing.step2Line',
        step3Title: 'landing.step3Title',
        step3Body: 'landing.step3Body',
        step3Line: 'landing.step3Line',
        step4Title: 'landing.step4Title',
        step4Body: 'landing.step4Body',
        step4Line: 'landing.step4Line',
        offlineTitle: 'landing.offlineTitle',
        offlineBody: 'landing.offlineBody',
        metricsTitle: 'landing.metricsTitle',
        metricsBody: 'landing.metricsBody',
        metricSkillsValue: 'landing.metricSkillsValue',
        metricSkillsLabel: 'landing.metricSkillsLabel',
        metricSessionValue: 'landing.metricSessionValue',
        metricSessionLabel: 'landing.metricSessionLabel',
        metricSignalValue: 'landing.metricSignalValue',
        metricSignalLabel: 'landing.metricSignalLabel',
        metricPlanValue: 'landing.metricPlanValue',
        metricPlanLabel: 'landing.metricPlanLabel',
        ctaTitle: 'landing.ctaTitle',
        ctaBody: 'landing.ctaBody',
    },
    language: {
        en: 'language.en',
        zhCN: 'language.zhCN',
        zhTW: 'language.zhTW',
        zhCNSub: 'language.zhCNSub',
        zhTWSub: 'language.zhTWSub',
    },
    learn: {
        greeting: 'learn.greeting',
        greetingSubtitle: 'learn.greetingSubtitle',
        continueKicker: 'learn.continueKicker',
        clearedToday: 'learn.clearedToday',
        clearedTodayHint: 'learn.clearedTodayHint',
        reviewDueCta: 'learn.reviewDueCta',
        pastSessions: 'learn.pastSessions',
        pastSessionsHint: 'learn.pastSessionsHint',
        yourProgress: 'learn.yourProgress',
        progress: 'learn.progress',
        ratingTally: 'learn.ratingTally',
        metaCardsCleared: 'learn.metaCardsCleared',
        metaXp: 'learn.metaXp',
        metaGateHeld: 'learn.metaGateHeld',
        metaGateNudged: 'learn.metaGateNudged',
        emptySessions: 'learn.emptySessions',
        emptyBlocks: 'learn.emptyBlocks',
        dayToday: 'learn.dayToday',
        dayYesterday: 'learn.dayYesterday',
        dayMon: 'learn.dayMon',
        dayTue: 'learn.dayTue',
        dayWed: 'learn.dayWed',
        dayThu: 'learn.dayThu',
        dayFri: 'learn.dayFri',
        daySat: 'learn.daySat',
        daySun: 'learn.daySun',
        pauseTitle: 'learn.pauseTitle',
        pauseBody: 'learn.pauseBody',
        pauseCta: 'learn.pauseCta',
        caughtUpTitle: 'learn.caughtUpTitle',
        caughtUpBody: 'learn.caughtUpBody',
        studyAheadHint: 'learn.studyAheadHint',
        syncing: 'learn.syncing',
        syncAudioRemaining: 'learn.syncAudioRemaining',
        syncUpToDate: 'learn.syncUpToDate',
        syncJustNow: 'learn.syncJustNow',
        syncFailed: 'learn.syncFailed',
        syncRetry: 'learn.syncRetry',
        pullToSync: 'learn.pullToSync',
        releaseToSync: 'learn.releaseToSync',
        audioIncompleteBody: 'learn.audioIncompleteBody',
    },
    legal: {
        title: 'legal.title',
        intro: 'legal.intro',
        jumpNavAria: 'legal.jumpNavAria',
        effective: 'legal.effective',
        loading: 'legal.loading',
        termsConditions: 'legal.termsConditions',
        documentFallback: 'legal.documentFallback',
    },
    nav: {
        learn: 'nav.learn',
        studyPlan: 'nav.studyPlan',
        cards: 'nav.cards',
        account: 'nav.account',
    },
    progress: {
        title: 'progress.title',
        subtitle: 'progress.subtitle',
        streakDays: 'progress.streakDays',
        streakFreezeReady: 'progress.streakFreezeReady',
        streakFrozen: 'progress.streakFrozen',
        xpEarned: 'progress.xpEarned',
        matureEntries: 'progress.matureEntries',
        retentionAtReview: 'progress.retentionAtReview',
        retentionNoData: 'progress.retentionNoData',
        byFamily: 'progress.byFamily',
        thisWeek: 'progress.thisWeek',
        pct: 'progress.pct',
        empty: 'progress.empty',
        dayInitialMon: 'progress.dayInitialMon',
        dayInitialTue: 'progress.dayInitialTue',
        dayInitialWed: 'progress.dayInitialWed',
        dayInitialThu: 'progress.dayInitialThu',
        dayInitialFri: 'progress.dayInitialFri',
        dayInitialSat: 'progress.dayInitialSat',
        dayInitialSun: 'progress.dayInitialSun',
        masterySection: 'progress.masterySection',
        skillMeta: {
            define: 'progress.skillMeta.define',
            listen: 'progress.skillMeta.listen',
            say: 'progress.skillMeta.say',
            readAloud: 'progress.skillMeta.readAloud',
            write: 'progress.skillMeta.write',
        },
        gapsSection: 'progress.gapsSection',
        gapsNote: 'progress.gapsNote',
    },
    reaccept: {
        title: 'reaccept.title',
        subtitle: 'reaccept.subtitle',
        read: 'reaccept.read',
        consent: 'reaccept.consent',
        agree: 'reaccept.agree',
        signingIn: 'reaccept.signingIn',
        docMeta: 'reaccept.docMeta',
        decline: 'reaccept.decline',
        declineTitle: 'reaccept.declineTitle',
        declineBody: 'reaccept.declineBody',
        backToReview: 'reaccept.backToReview',
        signOutForNow: 'reaccept.signOutForNow',
    },
    session: {
        cardPosition: 'session.cardPosition',
        reviewingPosition: 'session.reviewingPosition',
        nextCard: 'session.nextCard',
        seeResults: 'session.seeResults',
        reviewingBanner: 'session.reviewingBanner',
        studyTheseCardsAgain: 'session.studyTheseCardsAgain',
        resumeSet: 'session.resumeSet',
        backToResults: 'session.backToResults',
        rescoreYouRated: 'session.rescoreYouRated',
        rescoreNowRated: 'session.rescoreNowRated',
        toneNumber: 'session.toneNumber',
        toneName1: 'session.toneName1',
        toneName2: 'session.toneName2',
        toneName3: 'session.toneName3',
        toneName4: 'session.toneName4',
        pauseTitle: 'session.pauseTitle',
        pauseLead: 'session.pauseLead',
        pauseProgress: 'session.pauseProgress',
        keepGoing: 'session.keepGoing',
        endSetForNow: 'session.endSetForNow',
        promptDefine: 'session.promptDefine',
        promptListen: 'session.promptListen',
        promptSay: 'session.promptSay',
        promptReadAloud: 'session.promptReadAloud',
        promptWrite: 'session.promptWrite',
        dontKnow: 'session.dontKnow',
        showAnswer: 'session.showAnswer',
        checkAnswer: 'session.checkAnswer',
        cantRecall: 'session.cantRecall',
        gotItStart: 'session.gotItStart',
        newWord: 'session.newWord',
        mcNote: 'session.mcNote',
        addTones: 'session.addTones',
        toneName0: 'session.toneName0',
        preselectNote: 'session.preselectNote',
        toneResultCorrect: 'session.toneResultCorrect',
        tonesToFix: 'session.tonesToFix',
        sandhiHint: 'session.sandhiHint',
        replayHintFree: 'session.replayHintFree',
        replayHintCount: 'session.replayHintCount',
        slowReplay: 'session.slowReplay',
        stripRated: 'session.stripRated',
        stripMarked: 'session.stripMarked',
        stripNextIn: 'session.stripNextIn',
        stripSoon: 'session.stripSoon',
        retryLastCard: 'session.retryLastCard',
        keepRating: 'session.keepRating',
        dontKnowChip: 'session.dontKnowChip',
        knownChar: 'session.knownChar',
        inkUndo: 'session.inkUndo',
        inkClear: 'session.inkClear',
        inkOutline: 'session.inkOutline',
        strokeCount: 'session.strokeCount',
        promptDefineScratchHint: 'session.promptDefineScratchHint',
        strokeOrder: 'session.strokeOrder',
        strokeUnavailable: 'session.strokeUnavailable',
        strokesShown: 'session.strokesShown',
        strokePlay: 'session.strokePlay',
        strokePause: 'session.strokePause',
    },
    signIn: {
        title: 'signIn.title',
        subtitle: 'signIn.subtitle',
        emailLabel: 'signIn.emailLabel',
        emailHelp: 'signIn.emailHelp',
        submit: 'signIn.submit',
        linkExpiry: 'signIn.linkExpiry',
        switchPrompt: 'signIn.switchPrompt',
        switchLink: 'signIn.switchLink',
        emailRequired: 'signIn.emailRequired',
    },
    signUp: {
        title: 'signUp.title',
        subtitle: 'signUp.subtitle',
        displayNameLabel: 'signUp.displayNameLabel',
        displayNamePlaceholder: 'signUp.displayNamePlaceholder',
        emailLabel: 'signUp.emailLabel',
        emailHelp: 'signUp.emailHelp',
        submit: 'signUp.submit',
        submitting: 'signUp.submitting',
        consentLead: 'signUp.consentLead',
        consentMid: 'signUp.consentMid',
        consentTrail: 'signUp.consentTrail',
        termsLink: 'signUp.termsLink',
        privacyLink: 'signUp.privacyLink',
        switchPrompt: 'signUp.switchPrompt',
        switchLink: 'signUp.switchLink',
        displayNameRequired: 'signUp.displayNameRequired',
        emailRequired: 'signUp.emailRequired',
    },
    studyPlan: {
        groupCompleted: 'studyPlan.groupCompleted',
        groupNow: 'studyPlan.groupNow',
        groupLocked: 'studyPlan.groupLocked',
        subtitle: 'studyPlan.subtitle',
        pctMature: 'studyPlan.pctMature',
        typeLesson: 'studyPlan.typeLesson',
        ctagLocked: 'studyPlan.ctagLocked',
        manageTitle: 'studyPlan.manageTitle',
        manageSubline: 'studyPlan.manageSubline',
        manageLead: 'studyPlan.manageLead',
        manageGroupMakeYourOwn: 'studyPlan.manageGroupMakeYourOwn',
        manageInPlan: 'studyPlan.manageInPlan',
        manageSoon: 'studyPlan.manageSoon',
        pctMatureSaved: 'studyPlan.pctMatureSaved',
        manageEmpty: 'studyPlan.manageEmpty',
        allCourses: 'studyPlan.allCourses',
        planEmpty: 'studyPlan.planEmpty',
        planFilterEmpty: 'studyPlan.planFilterEmpty',
        courseRowMeta: 'studyPlan.courseRowMeta',
        coursePageAside: 'studyPlan.coursePageAside',
        coursePageLead: 'studyPlan.coursePageLead',
        makeYourOwnCurriculumTitle: 'studyPlan.makeYourOwnCurriculumTitle',
        makeYourOwnCurriculumSub: 'studyPlan.makeYourOwnCurriculumSub',
    },
    system: {
        VALIDATION: 'system.VALIDATION',
        ACCOUNT_NOT_FOUND: 'system.ACCOUNT_NOT_FOUND',
        ACCOUNT_ALREADY_EXISTS: 'system.ACCOUNT_ALREADY_EXISTS',
        INVALID_CODE: 'system.INVALID_CODE',
        CODE_EXPIRED: 'system.CODE_EXPIRED',
        TOO_MANY_ATTEMPTS: 'system.TOO_MANY_ATTEMPTS',
        SIGN_IN_EXPIRED: 'system.SIGN_IN_EXPIRED',
        EMAIL_INVALID: 'system.EMAIL_INVALID',
        DISPLAY_NAME_INVALID: 'system.DISPLAY_NAME_INVALID',
        SCRIPT_PREFERENCE_INVALID: 'system.SCRIPT_PREFERENCE_INVALID',
        TERMS_NOT_ACCEPTED: 'system.TERMS_NOT_ACCEPTED',
        CODE_FORMAT_INVALID: 'system.CODE_FORMAT_INVALID',
    },
} as const;

export const SupportedLocales = ['en', 'zh-CN', 'zh-TW'] as const;
export type SupportedLocale = typeof SupportedLocales[number];
